import {
  Component,
  ComponentFactoryResolver,
  Directive,
  ElementRef,
  Input,
  OnInit,
  ViewContainerRef
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
// eslint-disable-next-line max-len
import { ResetControlButtonComponent } from '@shared/components/most-used/reset-control-button/reset-control-button.component';


@Directive({
  selector: '[appResetControl]',
})
export class ResetControlDirective implements OnInit {
  @Input('appResetControl') control: UntypedFormControl;

  constructor(
    private el: ElementRef,
    private vcr: ViewContainerRef,
    private resolver: ComponentFactoryResolver,
  ) {
  }

  ngOnInit(): void {
    this.el.nativeElement.parentNode.style.position = 'relative';

    const component = this.vcr.createComponent(this.resolver.resolveComponentFactory(ResetControlButtonComponent))
    component.instance.control = this.control;
  }
}
